<script lang="ts">
  import Icon from "../../common/icons/Icon.svelte";
  import NavigatorLinkWrapper from "../../common/link/NavigatorLinkWrapper.svelte";
  import SocialButton from "./SocialButton.svelte";
  import checkMobileDevice from "../../common/is-mobile";
  import pageUrl from "../../../PageUrl";

  const copyRightText = "© Copyright 2022 Datadocs. All Rights Reserved.";
  const isMobile = checkMobileDevice();
  const navLinkProps = {
    textColor: "rgba(255, 255, 255, 0.5)",
    activeTextColor: "white",
    hoverTextColor: "rgba(255, 255, 255, 0.8)",
    disableTextColor: "rgba(255, 255, 255, 0.25)",
  };
</script>

<footer>
  <div class="main-footer" class:mobile={isMobile}>
    <div class="footer-container">
      <div class="logo">
        <Icon icon="datadocs-logo-home-light" width="137px" height="28px" />
      </div>

      <div class="bottom-nav">
        <nav>
          <ul>
            <li>
              <NavigatorLinkWrapper to={pageUrl.HOME} {...navLinkProps} underlineOnHover
                >Home</NavigatorLinkWrapper
              >
            </li>
            <li>
              <NavigatorLinkWrapper
                to={pageUrl.BLOG}
                {...navLinkProps}
                underlineOnHover>Blog</NavigatorLinkWrapper
              >
            </li>
            <li>
              <NavigatorLinkWrapper
                to={pageUrl.CAREERS}
                {...navLinkProps}
                underlineOnHover>Careers</NavigatorLinkWrapper
              >
            </li>
            <li>
              <NavigatorLinkWrapper
                to="/privacy"
                {...navLinkProps}
                underlineOnHover
                disabled>Privacy</NavigatorLinkWrapper
              >
            </li>
            <li>
              <NavigatorLinkWrapper
                to="/terms"
                {...navLinkProps}
                underlineOnHover
                disabled>Terms</NavigatorLinkWrapper
              >
            </li>
          </ul>
        </nav>
      </div>

      <!-- <div class="social-buttons opacity-0 flex flex-row items-center space-x-3">
        <SocialButton icon="facebook" iconWidth="10px" iconHeight="18px" />
        <SocialButton icon="twitter" iconWidth="18px" iconHeight="15px" />
        <SocialButton icon="pinterest" iconWidth="14px" iconHeight="18px" />
      </div> -->
    </div>

    <div class="copyright-container">
      <div class="copyright-content">
        {copyRightText}
      </div>
    </div>
  </div>
</footer>

<style lang="postcss">
  .main-footer {
    width: 100%;
    background: linear-gradient(103.11deg, #19013a 0%, #312d6e 100%);
  }

  .copyright-container {
    @apply relative w-full h-14 px-2 pb-2;
  }

  .copyright-content {
    @apply flex flex-row items-center justify-center w-full h-full text-white rounded;
    background: rgba(255, 255, 255, 0.1);
    font-size: 11px;
  }

  .footer-container {
    @apply flex flex-row items-center justify-evenly pt-10 pb-8;
    max-width: 1440px;
    margin: 0px auto;
  }

  @media (max-width: 640px) {
    .footer-container {
      @apply flex-col space-y-6;
    }
  }

  ul {
    @apply flex flex-row items-center space-x-5;
    font-size: 11px;
  }

  li {
    @apply relative box-border list-item uppercase;
  }
</style>
